module.exports = __webpack_public_path__ + "static/media/skyros.ac2948dd.jpg";